<template>
  <div>
    <P class="center">完成预支付，司机将按时来接你</P>
    <steps :imgData="orderObj.status"></steps>
    <div class="container" style='margin-bottom:250px;'>
      <div class="cardContainerTwo">
        <div>
          <driverMsg :driverData="orderObj"></driverMsg>
        </div>
        <div class="border-bottom"></div>
        <siteCard :userData="orderObj"></siteCard>
      </div>
    </div>
    <div class="fixed-Bottom">
      <a :href="orderObj.driverTelephone">
        <van-button
          type="default"
          size="large"
          round
          :class="[orderObj.isPay===0?'button-driver':'button-driver-active']"
        >联系司机</van-button>
      </a>

      <!-- v-if='orderObj.isPay===0' -->

      <div class="buttonIsPay" @click="buttonIsPayFun" v-if='orderObj.isPay===0'>
        <van-count-down :time="orderObj.payTime">
          <template v-slot="timeData">
            <span class="block">预支付(剩余:</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds }}</span>
            <span class="block">)</span>
          </template>
        </van-count-down>
      </div>
      <p v-if="orderObj.isPay===0" class="hint">在预支付剩余时间结束之前，如未成功支付，订单将被取消</p>
      <!-- v-show="orderObj.status===1"  -->
      <div v-show="orderObj.status===1">
        <!-- v-show="orderObj.isPay===0" -->
        <p class="cance" @click="cancelOrderFun">
          取消订单
          <van-icon name="arrow" />
        </p>
      </div>
    </div>
    <!-- 支付弹框 -->
    <van-popup v-model="IsPatyShow" position="bottom" closeable :style="{ height: '45%' }">
      <div class="ispay-title">预支付</div>
      <div class="ispay-flex">
        <span>订单金额</span>
        <span>{{orderObj.estimateMoney}}元</span>
      </div>
      <div class="ispay-money-container">
        <span class="money">{{orderObj.estimateMoney}}</span>元
      </div>
      <div class="ispay-wx">
        <span class="wx-item">
          <van-image width="15" height="15" :src="imgWx" style="margin-right:8px" />微信支付
        </span>
        <span>
          <van-image width="15" height="15" :src="imgYes" />
        </span>
      </div>
      <div class="ispay-button">
        <van-button type="default" size="large" round @click="payFun" :disabled="buttonState">确认支付</van-button>
      </div>
    </van-popup>
    <van-overlay :show="loadingShow" style="z-index=9999;backgorund:#fff">
      <div class="wrapper">
        <van-loading size="24px" vertical>加载中...</van-loading>
        <!-- <van-loading type="spinner" color="#1989fa" /> -->
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Notify, Dialog } from "vant";
import { cancellationOrder, receivOrder } from "@/api/orderReceiving.js";
import { wxPay, getOpenId, sendMessage } from "@/api/pay.js";
import { formattingTime } from "@/utils/public.js";
import uni from "@/utils/uni.webview.1.5.2.js";
//import wx from "weixin-js-sdk";

import { getToken } from "@/utils/auth.js";

import steps from "@/components/Steps/index.vue";
import siteCard from "@/components/SiteCard/index.vue";
import driverMsg from "@/components/driverMsg/index.vue";

export default {
  data() {
    return {
      buttonState: false,
      loginShow: true,
      isPay: 1,
      orderObj: {},
      IsPatyShow: false,
      wxPayObj: "",
      imgWx: require("../../assets/icon/icon-wx.png"),
      imgYes: require("../../assets/icon/icon-yes.png"),
      code: null,
      //定时器
      setInterval: null,
      //控制显示是否取消订单
      ordeShow: null,
      //控制显示加载中
      loadingShow: true,
      //支付环境    MWEB:H5支付   JSAPI：微信支付
      tradeType: null
    };
  },
  components: {
    steps,
    siteCard,
    driverMsg
  },
  created() {
    //订单信息
    this.receivOrderFun();
    //授权
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        //只有在微信浏览器才能调起授权
        getOpenId().then(res => {
          if (res.data.code === "2222") {
           window.location = "https://m.gcszwyc.com//webapi/wxlogin/getCode";
          }
          this.loadingShow = false;
        });
      }
    } else {
      this.loadingShow = false;
    }
  },
  mounted() {
    this.setInterval = this.setIntervalFun();
  },
  methods: {
    browserFun() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          //是移动端微信手机浏览器
          this.IsPatyShow = true;
        } else {
          //  Notify("请到微信浏览器支付");
          return;
        }
      } else {
        //pc
        this.IsPatyShow = true;
        console.log("pc");
        //Notify("请到微信浏览器支付");
        return;
      }
    },
    isWexin() {
		let isWechat = false;
		var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
		if (ua.match(/MicroMessenger/i) == "micromessenger") {
				isWechat = true;
		}
		return isWechat;
	},
    buttonIsPayFun() {
		let self = this;
		let isWechat = self.isWexin();
		
		let isWxapp = false;
		console.log('wx.miniProgram', wx.miniProgram);
		if(isWechat && wx.miniProgram) {
			  wx.miniProgram.getEnv(function (res) { //getEnv获取环境
				if (res.miniprogram) {
					  isWxapp = true;
					  let orderId = self.orderObj.orderSubId;
					  let data = {
							orderId: orderId,
							accessToken: getToken().replace('bearer ', '')
						};
					   
					   uni.postMessage({
							data: data
						});
						
						sendMessage({orderId: orderId}).then((res) => {
							let result = res.data;
							console.log('res', res);
							console.log('result', result);
							if (result.code === "0") {
								console.log('data', result.data);
							}
						});
						
						uni.navigateBack({
							delta: 1
						  });
						  
						return;
						
				} 
			  })
		} 
		console.log('isWxapp', isWxapp);
		if(!isWxapp) {
			//判断支付环境
			  this.IsPatyShow = true;
			//   this.browserFun();
		}
    },
    payFun() {
      let self = this;
      self.buttonState = true;
	  
      // if (typeof WeixinJSBridge == "undefined") {
      //   if (document.addEventListener) {
      //     document.addEventListener("WeixinJSBridgeReady", this.payFun, false);
      //   } else if (document.attachEvent) {
      //     document.attachEvent("WeixinJSBridgeReady", this.payFun);
      //     document.attachEvent("onWeixinJSBridgeReady", this.payFun);
      //   }
      // }

	  //支付
      wxPay().then(res => {
        let result = res.data;
        if (res.data.code === "0") {
          if (res.data.data.mwebUrl) {          
            //H5支付(后端做了浏览器判断)
            window.location.href = res.data.data.mwebUrl;
          } else {
            //微信支付
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: result.data.appId, //公众号名称，由商户传入
                timeStamp: result.data.timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: result.data.nonceStr, //随机串
                package: result.data.package,
                signType: result.data.signType, //微信签名方式：
                paySign: result.data.paySign //微信签名
              },

              function(res) {
                self.buttonState = false;
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  location.reload();
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                }
              }
            );
          }
        }
      });
    },
    cancelOrderFun() {
      Dialog.confirm({
        title: "温馨提示",
        message: "是否取消订单"
      }).then(() => {
        cancellationOrder().then(res => {
          let result = res.data;
          switch (result.code) {
            case "0": //取消订单成功
              Notify(result.msg);
              this.$router.push({ path: '/' })           
              break;
            case "0000": //没有登录
             // this.$router.go(-1)
               this.$router.push({ path: '/' })       
              break;
            default:
            //  this.$router.push({ path: '/' });
          }
        });
      });
    },
    receivOrderFun() {
      
  
      receivOrder().then(res => {
        let result = res.data;
        console.log("订单详情", result);
        if (result.code === "-1") {
        let leng = history.length-1      
        this.$router.go(-leng)
        }
        if (result.code === "0") {
        

          let stateTime = result.data.startDate;
          let endTime = result.data.endDate;
          let endHour = endTime.split(" ");
          let stateHour = stateTime.split(" ");
          let GMT = new Date(stateTime);
          let time = formattingTime("day:MM:dd", GMT);
          let timeObj = time.dataText + " " + stateHour[1] + "-" + endHour[1];
          this.orderObj.number = result.data.number + "人";
          let obj = {
            time: timeObj,
			orderSubId: result.data.orderSubId,
			orderSubNo: result.data.orderSubNo,
            averageScore: result.data.averageScore,
            brandModel: result.data.brandModel,
            driverName: result.data.driverName,
            driverTelephone: "tel:" + result.data.driverTelephone,
            driverType: result.data.driverType,
            endAddress: result.data.endAddress,
            endDate: result.data.endDate,
            estimateMoney: result.data.estimateMoney,
            headPortrait: result.data.headPortrait,
            isPay: result.data.isPay,
            number: result.data.number + "人",
            orderCount: result.data.orderCount,
            plateNumber: result.data.plateNumber,
            startAddress: result.data.startAddress,
            startDate: result.data.startDate,
            status: result.data.status,
            vehicleColor: result.data.vehicleColor,
            payTime: result.data.secCount * 1000
          };
          this.orderObj = obj;
        }
      });
    },
    setIntervalFun() {
      return setInterval(() => {
        this.receivOrderFun();
      }, 5000);
    },
  backChange(){
      this.$router.replace({name:'Home'})
    }

  },
  destroyed() {
    console.log('页面没了')
    clearInterval(this.setInterval);
    this.backChange()
     
  }
};
</script>
<style lang="scss" scoped>
$gray3: #333333;
$gray6: #666666;
$grayDF: #efefef;

$grayFF: #ffffff;
$red: #fb503b;

.center {
  margin-top: 60px;
  color: $gray6;
  font-size: 36px;
}
.container {
  margin-left: 60px;
  margin-right: 60px;
  margin-top: 60px;
  .cardContainerTwo {
    border-radius: 16px;
    box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.12);
  }
  .border-bottom {
    border-bottom: 1px solid $grayDF;
  }
}
.fixed-Bottom {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding:0 60px 15px 30px;
  background:#fff;
  .button {
    background: $red;
    border: 1px solid;
    letter-spacing: 1px;
  }
  .cance {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $gray6;
    margin: 20px 0;
    cursor: pointer;
  }
  .hint {
    font-size: 24px;
    text-align: center;
    color: $red;
    margin: 10px 0;
  }
  .button-driver {
    font-size: 40px;
    border: 1px solid $red;
    color: $red;
    margin-bottom: 20px;
    &:active {
      background: $red;
      color: $grayFF;
    }
  }
  .button-driver-active {
    font-size: 40px;
    background: $red;
    color: $grayFF;
    margin-bottom: 20px;
  }
  .buttonIsPay {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 116px;
    border-radius: 120px;
    background: $red;
    color: $grayFF;
    font-size: 40px;
    cursor: pointer;
    &:active {
      opacity: 0.9;
      color: $grayFF;
    }
    .van-count-down {
      font-size: 40px;
      color: $grayFF;
    }
  }
}
.ispay-title {
  text-align: center;
  line-height: 120px;
  border-bottom: 1px solid $grayDF;
}
.ispay-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  line-height: 150px;
  font-size: 34px;
}
.ispay-money-container {
  text-align: center;
  color: $gray6;
  .money {
    font-size: 72px;
    color: $gray3;
  }
}
.ispay-wx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  line-height: 100px;
  .wx-item {
    display: flex;
    align-items: center;
    font-size: 34px;
  }
}
.ispay-button {
  margin-top: 50px;
  padding: 0 2rem;
  .van-button {
    background: $red;
    color: $grayFF;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
}
</style>